import { View, Text, FlatList } from "react-native";
import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  setDoc,
} from "firebase/firestore";
import { auth, db } from "../firebase.js";

const FirebaseScreen = () => {
  const [productos, setProductos] = useState([]);

  useEffect(() => {
    getDocs(collection(db, "ProductosDRN")).then((docSnap) => {
      docSnap.forEach((doc) => {
        const { codigo, nombre, producto } = doc.data();
        productos.push(
          doc.data({
            codigo,
            nombre,
            producto,
          })
        );
      });
      setProductos(productos);

      console.log(productos);
    });
  }, []);

  return (
    <View>
      <Text>Firebase</Text>
      
      <FlatList
        data={productos}
        renderItem={({ item }) => <Text>. {item.nombre}</Text>}
      />
    </View>
  );
};

export default FirebaseScreen;
